import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule, isDevMode } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgLetModule } from 'ng-let';
import {
    AdminModule,
    ArmyBuilderConfig,
    ArmyBuilderSharedModule,
    ArmyBuilderStoreModule,
    HttpClientWithInFlightCacheModule,
    LanguageModule,
    MenuModule,
    PageLayoutModule,
    pageTransition,
    SafeHtmlModule,
    SettingsModule,
    UserModule,
    DEFAULT_SETTINGS_VALUE,
    ParseIconsConfig,
    getTranslateModuleConfig,
    EntityPreloadModule,
    TranslationPreloadModule,
    GAME_ID,
    DataSyncModule,
    SocialSigninModule,
    ImpersonationBarComponent,
    BillingSimulationBarComponent,
    BillingIssueWarningComponent,
    FeatureFlagDirective
} from 'army-builder-shared';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';
import { provideAuth, getAuth, initializeAuth, indexedDBLocalPersistence } from '@angular/fire/auth';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { Capacitor } from '@capacitor/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IonicStorageModule } from '@ionic/storage-angular';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FalloutConfig } from './config';
import { FalloutSettingsModule } from './settings/settings.module';
// import { falloutAppInitializerFactory } from './fallout-app.init';
import { ContentPage } from './home/content.page';
import { FalloutSubscriptionPageModule } from './subscription-page/subscription-page.module';
import { MyHammerConfig } from './global/hammer.config';
import { HomePage } from './home/home.page';
import { EQUIPMENT_TYPES } from './fww/global/models';
@NgModule({
    declarations: [AppComponent, HomePage, ContentPage],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            mode: 'md',
            navAnimation: pageTransition,
            innerHTMLTemplatesEnabled: true
        }),
        AppRoutingModule,
        ArmyBuilderStoreModule,
        ArmyBuilderSharedModule,
        NgLetModule,
        AdminModule,
        PageLayoutModule,
        LanguageModule,
        HttpClientWithInFlightCacheModule,
        SafeHtmlModule,
        UserModule,
        MenuModule,
        SettingsModule,
        IonicStorageModule.forRoot(),
        TranslateModule.forChild(getTranslateModuleConfig('global')),
        FalloutSettingsModule,
        FalloutSubscriptionPageModule,
        HammerModule,
        EntityPreloadModule,
        TranslationPreloadModule,
        DataSyncModule,
        SocialSigninModule,
        ImpersonationBarComponent,
        BillingSimulationBarComponent,
        BillingIssueWarningComponent,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode() && !Capacitor.isNativePlatform(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        FeatureFlagDirective
    ],
    providers: [
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => {
            if (Capacitor.isNativePlatform()) {
                return initializeAuth(getApp(), {
                    persistence: indexedDBLocalPersistence
                });
            } else {
                return getAuth();
            }
        }),

        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: ArmyBuilderConfig, useClass: FalloutConfig },
        FalloutConfig,
        Insomnia,
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: falloutAppInitializerFactory,
        //     deps: [TranslateService, Injector],
        //     multi: true
        // },
        {
            provide: DEFAULT_SETTINGS_VALUE,
            useValue: {
                itemFilters: { item: { type: EQUIPMENT_TYPES } },
                itemSort: {
                    item: {}
                },
                disableGrouping: {
                    item: {}
                },
                showIllegalItems: {
                    item: {}
                }
            }
        },
        {
            provide: ParseIconsConfig,
            useValue: {
                iconsFolder: 'assets/images/icons'
            }
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: GAME_ID,
            useValue: 'global'
        }
    ]
})
export class AppModule {
    constructor(
        public platform: Platform,
        private insomnia: Insomnia
    ) {
        this.platform.ready().then(() => {
            this.insomnia.keepAwake().then(
                () => console.log('insomnia success'),
                (e) => console.log('insomnia error', e)
            );
        });
    }
}
